import { Http } from '@/http/http';
import { MARK_OPERATION_SEEN } from './types';

const markOperationSeen = ({ commit }, { operationId, markAll }) => {
  Http.post(`/operation/${operationId}/seen`)
    .catch(console.error);
  commit(MARK_OPERATION_SEEN, markAll);
};

export const actions = {
  [MARK_OPERATION_SEEN]: markOperationSeen,
};
